import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    TextField,
    CircularProgress,
    Button,
    Stack,
} from '@mui/material';
import { ConfigContext } from '../../Config/ConfigContext';
import useForm from '../../hooks/useForm';
import http from '../../utils/http';
import { debounce } from 'lodash';

const saveField = debounce(async (data, uri) => {
    await http.put(data, uri);
}, 500);

const onLoad = async ({ values }) => {
    const emailCampaign = await http.get({}, `${values.config.uri.base}/email-campaign/${values._id}`);
    return {
        ...values,
        ...emailCampaign,
        loading: false,
    };
};

export default function EmailCampaignDetail() {
    const { emailCampaignId } = useParams();
    const { config } = useContext(ConfigContext);
    const { state, onChange } = useForm({
        debug: true,
        initialState: {
            config,
            _id: emailCampaignId,
            name: '',
            description: '',
            emailList: [],
            startDate: '',
            endDate: '',
            status: '',
            campaignType: '',
            createdBy: '',
            createdAt: null,
            updatedAt: null,
            updatedBy: '',
            loading: true,
        },
        onLoad
    });

    const handleDelete = async () => {
        await http.delete({}, `${config.uri.base}/email-campaign/${state.values._id}`);
        window.location.href = '/email-campaigns';
    };

    return (
        <Container>
            {state.values.loading ? (
                <CircularProgress />
            ) : (
                <>
                    <Box sx={{ marginTop: '20px' }}>
                        <Typography variant="h5">Email Campaign Details</Typography>
                        <Stack spacing={2} sx={{ marginTop: '20px' }}>
                            <TextField
                                label="Name"
                                value={state.values.name}
                                onChange={(e) => {
                                    onChange(e.target.value, 'name');
                                    saveField({ name: e.target.value }, `${config.uri.base}/email-campaign/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Description"
                                value={state.values.description}
                                onChange={(e) => {
                                    onChange(e.target.value, 'description');
                                    saveField({ description: e.target.value }, `${config.uri.base}/email-campaign/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Email List"
                                value={state.values.emailList.join(', ')}
                                onChange={(e) => {
                                    const value = e.target.value.split(', ');
                                    onChange(value, 'emailList');
                                    saveField({ emailList: value }, `${config.uri.base}/email-campaign/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Start Date"
                                value={state.values.startDate}
                                onChange={(e) => {
                                    onChange(e.target.value, 'startDate');
                                    saveField({ startDate: e.target.value }, `${config.uri.base}/email-campaign/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="End Date"
                                value={state.values.endDate}
                                onChange={(e) => {
                                    onChange(e.target.value, 'endDate');
                                    saveField({ endDate: e.target.value }, `${config.uri.base}/email-campaign/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Status"
                                value={state.values.status}
                                onChange={(e) => {
                                    onChange(e.target.value, 'status');
                                    saveField({ status: e.target.value }, `${config.uri.base}/email-campaign/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Campaign Type"
                                value={state.values.campaignType}
                                onChange={(e) => {
                                    onChange(e.target.value, 'campaignType');
                                    saveField({ campaignType: e.target.value }, `${config.uri.base}/email-campaign/${state.values._id}`);
                                }}
                                fullWidth
                            />
                        </Stack>
                    </Box>
                    <Box sx={{ marginTop: '20px' }}>
                        <Typography variant="h6">Read-Only Fields</Typography>
                        <Stack spacing={2}>
                            <Typography><strong>ID:</strong> {state.values._id}</Typography>
                            <Typography><strong>Created By:</strong> {state.values.createdBy}</Typography>
                            <Typography><strong>Created At:</strong> {state.values.createdAt}</Typography>
                            <Typography><strong>Updated At:</strong> {state.values.updatedAt}</Typography>
                            <Typography><strong>Updated By:</strong> {state.values.updatedBy}</Typography>
                        </Stack>
                    </Box>
                    <Box sx={{ marginTop: '20px' }}>
                        <Button variant="contained" color="error" onClick={handleDelete}>
                            Delete Email Campaign
                        </Button>
                    </Box>
                </>
            )}
        </Container>
    );
}
